// Renders a category icon — handles both emoji and image paths automatically.
// Usage: <CategoryIcon icon={cat.icon} size={24} />
//
// In courses.js, set icon to either:
//   icon: "🤖"                              ← emoji
//   icon: "/category-icons/ai-ml.svg"        ← image (file in public/ folder)
//   icon: "https://example.com/icon.png"     ← image (external URL)

export default function CategoryIcon({ icon, size = 22 }) {
  if (!icon) return null;

  const isImage =
    icon.startsWith("/") ||
    icon.startsWith("http://") ||
    icon.startsWith("https://");

  if (isImage) {
    return (
      <img
        src={icon}
        alt=""
        style={{
          width:  size,
          height: size,
          objectFit: "contain",
          display: "inline-block",
          verticalAlign: "middle",
        }}
      />
    );
  }

  return (
    <span style={{ fontSize: size, lineHeight: 1, display: "inline-block" }}>
      {icon}
    </span>
  );
}
